module.exports = __webpack_public_path__ + "assets/1317da935787fe86d60f69fe78bc9c44.png";